/* global globalThis */
import React from "react";
import PropTypes from "prop-types";
import Tabs from "@material-ui/core/Tabs";
import Tab from "@material-ui/core/Tab";
import {
  useStyles,
  useTranslations,
} from "examsbook-react-sdk/custom-hooks";
import { Box, Grid, Typography } from "@material-ui/core";
import { useTheme } from "../../constants/themeProvider";
import { useSelector } from "react-redux";
import LockIcon from '@material-ui/icons/Lock';

export default function CTabs(props) {
  const {
    mySectionData,
    isCourseExpired,
    neverExpired,
    isCertCompleted,
    selectedTab,
    nav,
    handleTabChange,
  } = props;
  const settingsData = useSelector((state) => state.settingsReducers.settingsData?.data);
  const certificateValue = settingsData?.data?.[0]
    ? settingsData?.data?.[0]?.customization?.certification
    : false;
  const t = useTranslations();
  const theme = useTheme();
  const drawerToggle = globalThis?.localStorage?.getItem("openDrawerStatus");

  const styles = {
    title: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "16px",
      display: "flex",
      justifyContent: "center",
      color: "#000000",
      textTransform: "capitalize",
      textAlign: "left",
    },
    titleResize: {
      fontSize: "16px",
      fontWeight: 500,
      lineHeight: "16px",
      display: "flex",
      justifyContent: "center",
      color: "#000000",
      textTransform: "capitalize",
      textAlign: "left",
      "@media (max-width: 767px)": {
        width: "100%",
        textAlign: "center",
        fontSize: "11px",
        fontWeight: 700,
      },
    },
    iconTab: {
      alignItems: "center",
    },
    iconTabSelected: {
      borderBottom: `1px solid ${theme?.primaryColor}`,
      alignItems: "center",
      opacity: "1",
    },
    activeLogo: {
      transition: ".2s all linear",
    },
    activeTitle: {
      color: theme?.primaryColor,
      fontSize: "16px",
      fontWeight: 600,
      "@media (max-width: 767px)": {
        fontSize: 11,
        fontWeight: 700,
      },
      "@media (min-width: 960px) and (max-width: 1200px)": {
        fontSize: "11px",
        fontWeight: 700,
      },
    },
  };

  const classes = useStyles(styles)();
  const liveClassLength = mySectionData?.data?.liveClass?.length || 0;
  const evaluationTestLength = mySectionData?.data?.evaluationTest?.length || 0;
  const isCompactTab = Boolean(drawerToggle) && (globalThis?.innerWidth || 0) < 1200;

  const renderTabItem = (item, index) => {
    const label = item?.label;
    const isActive = selectedTab === index;
    const isLiveClassTabHidden = index === 1 && liveClassLength === 0;
    const isEvaluationTabHidden = index === 2 && evaluationTestLength === 0;
    const isCertificateTab = index === 3;
    const isCertificateVisible = certificateValue === true && evaluationTestLength !== 0;
    const shouldShowTab = index < 3 || (isCertificateTab && isCertificateVisible);
    const isCertUnlockedOnExpiredCourse = isCertificateTab && neverExpired && isCertCompleted;
    const isExpiredLocked = isCourseExpired && index > 0 && !isCertUnlockedOnExpiredCourse;

    if (isLiveClassTabHidden || isEvaluationTabHidden || !shouldShowTab) {
      return null;
    }

    return (
      <Grid item xs={3} md={3} lg={3} onClick={() => handleTabChange(index)} key={String(label)}>
        <Tab
          style={{ width: "100%" }}
          label={
            <Box className="feature-buttons">
              <Box
                className={`${isCompactTab ? classes.logoResize : classes.logo} ${isActive ? classes.activeLogo : ""} `}
              >
                <Box
                  className={`${isCompactTab ? classes.titleResize : classes.title} ${isActive && !isExpiredLocked ? classes.activeTitle : ""}`}
                  style={isExpiredLocked ? { opacity: 0.5 } : {}}
                >
                  {isExpiredLocked && <LockIcon style={{ fontSize: '14px', marginRight: '4px', color: '#9e9e9e' }} />}
                  <Typography variant="inherit">{t(label)}</Typography>
                </Box>
              </Box>
            </Box>
          }
          className={isActive ? classes.iconTabSelected : classes.iconTab}
        />
      </Grid>
    );
  };

  return (
    <Tabs
      value={selectedTab}
      aria-label="course tabs"
      indicatorColor="primary"
      style={{padding: '0px 16px'}}
    >
      <Grid item container lg={8}>
        {nav?.map((item, index) => renderTabItem(item, index))}
      </Grid>
    </Tabs>
  );
}

CTabs.propTypes = {
  nav: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
    })
  ),
  selectedTab: PropTypes.number,
  handleTabChange: PropTypes.func,
  mySectionData: PropTypes.shape({
    data: PropTypes.shape({
      liveClass: PropTypes.array,
      evaluationTest: PropTypes.array,
    }),
  }),
  isCourseExpired: PropTypes.bool,
  neverExpired: PropTypes.bool,
  isCertCompleted: PropTypes.bool,
};
